import loadImage from 'blueimp-load-image';

function fixRotationOfFile(file: File) {
    return new Promise((resolve) => {
        const convertImageToBlob = (img: any) => {
            if ('toBlob' in img) {
                img.toBlob((blob: any) => {
                    resolve(blob);
                }, file.type);
            } else {
                // if the browser doesn't support it, load the polyfill and attach it as a script tag
                const script = document.createElement('script');
                document.body.appendChild(script);
                script.src =
                    'https://cdnjs.cloudflare.com/ajax/libs/javascript-canvas-to-blob/3.28.0/js/canvas-to-blob.min.js';
                script.async = true;
                script.onload = () =>
                    (img as any).toBlob((blob: Blob) => {
                        resolve(blob);
                    }, file.type);
            }
        };

        loadImage(file, convertImageToBlob, {
            orientation: true,
            canvas: true,
        });
    });
}

export const fixRotation = async (file: File) => {
    return await fixRotationOfFile(file);
};
